import React, { FunctionComponent } from 'react';
import { Col, DateView, DayOfTheWeek, Wrapper } from './TourPeriod.style';
import { DateYMDString } from '@lt/api/dist/types/date';
import { formatDateToDayMonth, getDateName } from '@lt/components/utils/date';

// TODO
type Props = {
  startDate: DateYMDString;
  endDate: DateYMDString;
};

export const TourPeriod: FunctionComponent<Props> = ({ startDate, endDate }) => {
  return (
    <Wrapper>
      <Col>
        <DateView>{formatDateToDayMonth(startDate)}</DateView>
        <DayOfTheWeek>{getDateName(startDate)}</DayOfTheWeek>
      </Col>
      <Col>
        <DateView>—</DateView>
      </Col>
      <Col>
        <DateView>{formatDateToDayMonth(endDate)}</DateView>
        <DayOfTheWeek>{getDateName(endDate)}</DayOfTheWeek>
      </Col>
    </Wrapper>
  );
};
